export default __webpack_public_path__ + "static/media/Alex Z.f299e8ae.png";